import React, { Component } from "react";
import { Position, Tooltip } from "@blueprintjs/core";
import ClassNames from "classnames";
import { isEmpty, isNumber } from "lodash";
import { formatValidityPeriod } from "../../../../../utils";
import styles from "../../../../../styles/Campaigns/CampaignTree.module.scss";

const isAdmin = process.env.REACT_APP_IS_ADMIN;

const defaultCampaignData = [
  {
    id: "name",
    label: "Campaign Name",
    value: "Enter campaign name",
  },
  ...(isAdmin
    ? [
        {
          id: "companyName",
          label: "Company",
          value: "Select company",
        },
      ]
    : []),
  {
    id: "campaignTargetTypeName",
    label: "Campaign Type",
    value: "Select campaign type",
  },
  {
    id: "advertiserName",
    label: "Client",
    value: "Select client",
  },
  {
    id: "countries",
    label: "Country",
    value: "Select country",
  },
  {
    id: "validity",
    label: "Validity",
    value: "Select campaign validity",
  },
  // {
  //   id: "maxPlaysPerScreen",
  //   label: "Max Play Per Screen",
  //   value: "-",
  // },
  // {
  //   id: "budgetPlays",
  //   label: "Budgeted Plays",
  //   value: "-",
  // },
  // {
  //   id: "totalEstimatedPlays",
  //   label: "Estd. Plays",
  //   value: "-",
  // },
  // {
  //   id: "actualPlays",
  //   label: "Actual Plays",
  //   value: "-",
  // },
  {
    id: "campaignValue",
    label: "Campaign Value",
    value: "-",
  },
  {
    id: "contentStatus",
    label: "Content",
    value: "Add Content",
  },
];

export default class CampaignCard extends Component {
  state = {
    isExpanded: this.props.isExpanded,
  };

  static defaultProps = {
    isExpanded: true,
    showCollapse: false,
  };

  handleCardToggle = (isExpanded) => {
    if (this.props.onCardToggle) {
      this.props.onCardToggle(isExpanded);
    }

    this.setState({
      isExpanded: isExpanded,
    });
  };

  formatCampaignValues = (defaultValue, campaignData) => {
    const value = campaignData && campaignData[defaultValue.id];

    if (defaultValue.id === "contentStatus" && value === false) {
      return <span style={{ color: "red" }}>Not Available</span>;
    }

    if (isEmpty(value) && !isNumber(value)) return defaultValue.value;

    if (defaultValue.id === "validity") {
      return formatValidityPeriod(value, "DD MMM YYYY");
    }

    if (defaultValue.id === "countries") {
      return value.map((c) => c.name).join(", ");
    }

    if (defaultValue.id === "name" && value && value.length > 30) {
      return (
        <Tooltip
          content={<div style={{ maxWidth: "250px", wordBreak: "break-word" }}>{value}</div>}
          position={Position.AUTO}
          hoverOpenDelay={300}
          usePortal={true}
        >
          <div className={styles.twoLineTruncate}>{value}</div>
        </Tooltip>
      );
    }

    return value;
  };

  render() {
    const { campaignData, children } = this.props;

    const updatedCampaignData = [...defaultCampaignData];

    return (
      <div className={ClassNames(styles.cardContainer, styles.campaignContainer)}>
        <div className={styles.cardItemWrapper}>
          {updatedCampaignData.map((itemDefaultData, index) => {
            if (
              itemDefaultData.id === "contentStatus" &&
              campaignData[itemDefaultData.id] === true
            ) {
              return null;
            }
            return (
              <div key={index} className={styles.itemContainer}>
                <div className={styles.labelContainer}>
                  <div className={styles.label}>{itemDefaultData.label}</div>
                </div>
                <div className={styles.infoValue}>
                  {this.formatCampaignValues(itemDefaultData, campaignData)}
                </div>
              </div>
            );
          })}
        </div>
        {this.state.isExpanded && (
          <div className={`${styles.child} ${styles.campaign}`}>{children}</div>
        )}
      </div>
    );
  }
}
